"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpecificitiesOfStoreFields = SpecificitiesOfStoreFields;
exports.setSpecificitiesValuesToFormData = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _core = require("@material-ui/core");
var _formik = require("formik");
var _Translations = require("react-platform-components/dist/Translations");
var _RenderSection = require("./RenderSection");
var _RenderSpecificities = require("./RenderSpecificities");
var _moment = _interopRequireDefault(require("moment"));
var _config = require("react-platform-components/dist/config");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var CategoryOfStoreField = null;
try {
  CategoryOfStoreField = require('react-platform-category-of-store/dist/CategoryOfStore/CategoryOfStoreField').default;
} catch (error) {
  console.log('errror categori of store');
}
var setSpecificitiesValuesToFormData = function setSpecificitiesValuesToFormData(formData) {
  var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "store_specificities";
  var data = arguments.length > 2 ? arguments[2] : undefined;
  var store = arguments.length > 3 ? arguments[3] : undefined;
  // specificities to be added
  var specificitiesToBeAdded = [];
  if (data.specificities && !_lodash.default.isEmpty(data.specificities)) {
    data.specificities.forEach(function (item, index) {
      specificitiesToBeAdded.push(item.specificity.id);
      if (item.choice) {
        formData.append("".concat(fieldName, "-").concat(index, "-specificity"), item.specificity.id);
        if (item.specificity.type === "date") {
          formData.append("".concat(fieldName, "-").concat(index, "-date"), (0, _moment.default)(item.choice, "DD-MM-YYYY").format("YYYY-MM-DD"));
        } else if (item.specificity.type === "m_list") {
          formData.append("".concat(fieldName, "-").concat(index, "-choices"), item.choice.join("|"));
        } else if (item.specificity.type === "free") {
          formData.append("".concat(fieldName, "-").concat(index, "-free"), item.choice);
        } else if (item.specificity.type === "number") {
          formData.append("".concat(fieldName, "-").concat(index, "-number"), item.choice);
        } else if (item.specificity.type === "range") {
          formData.append("".concat(fieldName, "-").concat(index, "-range_min"), item.choice[0]);
          formData.append("".concat(fieldName, "-").concat(index, "-range_max"), item.choice[1]);
        } else if (item.specificity.type === "boolean") {
          formData.append("".concat(fieldName, "-").concat(index, "-boolchoice"), item.choice);
        } else if (item.specificity.type === "phone") {
          if (item.choice.length < _config.PHONE_MIN_LENGTH) {
            formData.append("".concat(fieldName, "-").concat(index, "-specificity"), item.specificity.id);
            formData.append("".concat(fieldName, "-").concat(index, "-inline_delete"), "true");
          } else {
            formData.append("".concat(fieldName, "-").concat(index, "-phone"), item.choice);
          }
        } else if (item.specificity.type === "link") {
          formData.append("".concat(fieldName, "-").concat(index, "-link"), item.choice);
        } else if (item.specificity.type === "document") {
          // handle the deleted files
          var productSpecificity = _lodash.default.find(store.store_specificities, function (productSpecificity) {
            return productSpecificity.specificity.id === item.specificity.id;
          });
          if (productSpecificity) {
            _lodash.default.forEach(productSpecificity.choice || [], function (file) {
              if (!_lodash.default.find(item.choice || [], function (item) {
                return item.name === file.name;
              })) {
                formData.append("".concat(fieldName, "-").concat(index, "-files-delete-specific-files"), file.name);
              }
            });
          }
          if (_lodash.default.find(item.choice || [], function (item) {
            return item instanceof File;
          })) {
            // handle the new uploaded files
            _lodash.default.forEach(item.choice || [], function (item) {
              if (item instanceof File) {
                formData.append("".concat(fieldName, "-").concat(index, "-files"), item);
              }
            });
          } else {
            // we need to send files as empty if there no new file to upload
            formData.append("".concat(fieldName, "-").concat(index, "-files"), undefined);
          }
        } else {
          formData.append("".concat(fieldName, "-").concat(index, "-choice"), item.choice);
        }
      } else {
        if (item.specificity.type === "link") {
          formData.append("".concat(fieldName, "-").concat(index, "-specificity"), item.specificity.id);
          formData.append("".concat(fieldName, "-").concat(index, "-inline_delete"), "true");
        }
      }
    });
  }
  // specificities to be deleted
  if (store.store_specificities && store.store_specificities.length > 0) {
    store.store_specificities.forEach(function (item, index) {
      var isFound = specificitiesToBeAdded.some(function (specificity) {
        return specificity === item.specificity.id;
      });
    });
  }
  delete data.specificities;
};
exports.setSpecificitiesValuesToFormData = setSpecificitiesValuesToFormData;
function SpecificitiesOfStoreFields(props) {
  var _useFormikContext = (0, _formik.useFormikContext)(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return {
        categories: state.categoryOfStoreReducer ? state.categoryOfStoreReducer.categories : null,
        specificities: state.specificityOfStoreReducer.specificities,
        store: state.storeReducer
      };
    }),
    categories = _useSelector.categories,
    specificities = _useSelector.specificities,
    store = _useSelector.store;
  var isMd = (0, _core.useMediaQuery)("(max-width: 810px)");
  var sectionsListing = function sectionsListing() {
    var sections = [];
    specificities.map(function (specificity) {
      var filtre = sections.filter(function (item) {
        var _specificity$section;
        return (item === null || item === void 0 ? void 0 : item.id) === (specificity === null || specificity === void 0 ? void 0 : (_specificity$section = specificity.section) === null || _specificity$section === void 0 ? void 0 : _specificity$section.id);
      });
      if (filtre.length === 0) {
        sections.push(specificity === null || specificity === void 0 ? void 0 : specificity.section);
      }
    });
    return sections.filter(function (item) {
      return item !== null && item !== undefined;
    }).sort(function (element, nextElement) {
      return element.position - nextElement.position;
    });
  };
  var specificitiesWithoutSections = function specificitiesWithoutSections() {
    if (!_lodash.default.isEmpty(values.specificities)) return _lodash.default.uniqBy(values.specificities.filter(function (item) {
      return !item.specificity.section;
    }), "specificity");
    return [];
  };
  function addSpecificities() {
    var _selectedCategory$dee;
    // // Find selected category
    var selectedCategory = categories.find(function (item) {
      return item.id === values.category;
    });
    setFieldValue('specificities', selectedCategory === null || selectedCategory === void 0 ? void 0 : (_selectedCategory$dee = selectedCategory.deep_category_specificities) === null || _selectedCategory$dee === void 0 ? void 0 : _selectedCategory$dee.map(function (item) {
      var specificity = _lodash.default.find(specificities, {
        id: item.specificity.id
      });
      return _objectSpread(_objectSpread(_objectSpread({
        choice: null
      }, item), _lodash.default.find(props.store.store_specificities, function (specificity) {
        return specificity.specificity.id === item.specificity.id;
      })), {}, {
        specificity: specificity
      });
    }));
  }
  (0, _react.useEffect)(function () {
    if (!CategoryOfStoreField) {
      setFieldValue("specificities", specificities.map(function (item) {
        var specificity = _lodash.default.find(specificities, {
          id: item.id
        });
        return _objectSpread(_objectSpread(_objectSpread({
          choice: null
        }, item), _lodash.default.find(props.store.store_specificities, function (specificity) {
          return specificity.id === item.id;
        })), {}, {
          specificity: specificity
        });
      }));
    }
  }, []);
  (0, _react.useEffect)(function () {
    if (CategoryOfStoreField && values.category && values.category !== null) addSpecificities();
  }, [values.category]);
  var sections = sectionsListing();
  var specificitiesWithoutSectionsListing = specificitiesWithoutSections();
  if (CategoryOfStoreField) {
    if (!_lodash.default.get(values, 'category') || !values.specificities || _lodash.default.isEmpty(values.specificities)) {
      // hide this fieds if the category is not selected yet
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 12,
      style: {
        marginTop: 35
      }
    }, /*#__PURE__*/_react.default.createElement(_formik.FieldArray, {
      name: "specificities",
      render: function render(arrayHelpers) {
        return /*#__PURE__*/_react.default.createElement(_core.Grid, {
          container: true,
          item: true,
          xs: 12,
          alignItems: "center"
        }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
          variant: "subtitle1",
          className: "pl-2",
          style: {
            fontSize: '1.1rem',
            color: '#908f8f'
          }
        }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: "Specificities"
        }))), specificitiesWithoutSectionsListing.map(function (item, index) {
          return /*#__PURE__*/_react.default.createElement(_RenderSpecificities.RenderSpecificities, {
            key: index,
            storeSpecificity: item,
            isMd: props.isMd
          });
        }), specificities && specificities.length > 0 && sections.map(function (item, index) {
          return /*#__PURE__*/_react.default.createElement(_RenderSection.RenderSection, {
            key: index,
            item: item,
            isMd: isMd
          });
        }));
      }
    }));
  } else {
    var Container = props.container || DefaultContainer;
    var showSpecificitiesTitle = props.showSpecificitiesTitle;
    return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_formik.FieldArray, {
      name: "specificities",
      render: function render(arrayHelpers) {
        return /*#__PURE__*/_react.default.createElement(_core.Grid, {
          container: true,
          item: true,
          xs: 12,
          alignItems: "center"
        }, showSpecificitiesTitle && /*#__PURE__*/_react.default.createElement(_core.Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
          variant: "subtitle1",
          className: "pl-2",
          style: {
            fontSize: '1.1rem',
            color: '#908f8f'
          }
        }, /*#__PURE__*/_react.default.createElement(_Translations.IntlMessages, {
          id: "Specificities"
        }))), specificitiesWithoutSectionsListing.map(function (item, index) {
          return /*#__PURE__*/_react.default.createElement(_RenderSpecificities.RenderSpecificities, {
            key: index,
            storeSpecificity: item,
            isMd: isMd
          });
        }), specificities && specificities.length > 0 && sections.map(function (item, index) {
          return /*#__PURE__*/_react.default.createElement(_RenderSection.RenderSection, {
            key: index,
            item: item,
            isMd: isMd
          });
        }));
      }
    }));
  }
}
var DefaultContainer = function DefaultContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12,
    style: {
      marginTop: 35
    }
  }, children);
};